import type { PollResponse } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/api";
import { NEW_POLL_OPTION } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/constants";

export interface PollFormValues {
  allow_members_to_view_results: boolean;
  closes_at: string | null;
  enable_poll_duration: boolean;
  poll_options: { id?: number; value: string }[];
  title: string;
}

export const getPollDefaultValues = (
  pollForEdit?: PollResponse,
): PollFormValues =>
  pollForEdit
    ? {
        title: pollForEdit.title,
        poll_options: pollForEdit.poll_options,
        allow_members_to_view_results:
          pollForEdit.allow_members_to_view_results,
        enable_poll_duration: !!pollForEdit.closes_at,
        closes_at: pollForEdit.closes_at ?? null,
      }
    : {
        title: "",
        poll_options: [NEW_POLL_OPTION],
        allow_members_to_view_results: true,
        enable_poll_duration: false,
        closes_at: null,
      };
